/**
 * Strip a wrapping markdown code fence when the whole assistant reply is
 * fenced prose (common for SITREPs). Leaves real code samples untouched.
 *
 * @param {string} content
 * @returns {string}
 */
export function unwrapMarkdownFence(content) {
  if (typeof content !== 'string' || !content.trim()) return content;

  const trimmed = content.trim();
  const wholeFence = trimmed.match(
    /^```(?:markdown|md|text|sitrep|plain)?\s*\r?\n([\s\S]*?)\r?\n```\s*$/i,
  );
  if (wholeFence) return wholeFence[1];

  if (!trimmed.startsWith('```')) return content;

  const inner = trimmed
    .replace(/^```(?:[\w-]*)?\s*\r?\n?/, '')
    .replace(/\r?\n?```\s*$/, '');

  const looksLikeReport =
    /(^|\n)\s*#{1,3}\s+\S/.test(inner)
    || /\bSITREP\b/i.test(inner)
    || /\*\*[A-Za-z][^*]+\*\*/.test(inner);

  return looksLikeReport ? inner : content;
}
